var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3129_4242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0354004,
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3129_4242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30775 19.5354C3.80258 19.5354 3.375 19.3604 3.025 19.0104C2.675 18.6604 2.5 18.2328 2.5 17.7277V6.34315C2.5 5.83798 2.675 5.4104 3.025 5.0604C3.375 4.7104 3.80258 4.5354 4.30775 4.5354H19.6923C20.1974 4.5354 20.625 4.7104 20.975 5.0604C21.325 5.4104 21.5 5.83798 21.5 6.34315V17.7277C21.5 18.2328 21.325 18.6604 20.975 19.0104C20.625 19.3604 20.1974 19.5354 19.6923 19.5354H4.30775ZM12.75 18.0354H15.625V6.0354H12.75V18.0354ZM8.375 18.0354H11.25V6.0354H8.375V18.0354ZM4.30775 18.0354H6.875V6.0354H4.30775C4.21792 6.0354 4.14417 6.06423 4.0865 6.1219C4.02883 6.17957 4 6.25332 4 6.34315V17.7277C4 17.8175 4.02883 17.8912 4.0865 17.9489C4.14417 18.0066 4.21792 18.0354 4.30775 18.0354ZM17.125 18.0354H19.6923C19.7821 18.0354 19.8558 18.0066 19.9135 17.9489C19.9712 17.8912 20 17.8175 20 17.7277V6.34315C20 6.25332 19.9712 6.17957 19.9135 6.1219C19.8558 6.06423 19.7821 6.0354 19.6923 6.0354H17.125V18.0354Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekly);
export default __webpack_public_path__ + "static/media/Weekly.b0dd421d675e1e50dfb570227087f9f6.svg";
export { ForwardRef as ReactComponent };